import { MIME_TYPES } from "@mantine/dropzone"
import {
  IconFile,
  IconPdf,
  IconPhoto,
  IconFileSpreadsheet,
} from "@tabler/icons-react"

interface Props {
  mimeType: string
}

export function FileIcon({ mimeType }: Props) {
  if (mimeType.startsWith("image/")) {
    return <IconPhoto size={20} />
  }

  if (mimeType === MIME_TYPES.pdf) {
    return <IconPdf size={20} />
  }

  if (mimeType === MIME_TYPES.xls || mimeType === MIME_TYPES.xlsx) {
    return <IconFileSpreadsheet size={20} />
  }

  return <IconFile size={20} />
}
